export type ActionCallback = (err: boolean) => void;
export interface ICookieStorageItem { key: string; data: string; }

// Definições padrões de storage
export const DEFAULT_COOKIE_DOMAIN = window.location.hostname;
export const DEFAULT_COOKIE_EXPIRES_DATE = '1969-01-01';

export class CookieStorage {

    /**
     * Verifica se um cookie existe
     *
     * @param  {string} key
     */
    public existItem = (key: string): boolean => !!this.getItem(key);

    /**
     * Registra ou altera um cookie
     *
     * @param  {string} key
     * @param  {string} data
     * @param  {Date} expiresIn
     * @param  {string=window.location.host} domain
     * @param  {string='/'} domain
     */
    public setItem(key: string, data: string, expiresIn: Date, domain: string = DEFAULT_COOKIE_DOMAIN, path: string = '/') {
        // tslint:disable-next-line:max-line-length
        document.cookie = `${key.trim()}=${data}; expires=${expiresIn.toUTCString()}; max-age=${expiresIn.toUTCString()}; domain=${domain.trim()}; path=${path}`;
    }

    /**
     * Retorna o valor de um cookie
     *
     * @param  {string} key
     * @returns string
     */
    public getItem(key: string): string {

        // Detecta se cookie existe, se sim guarda sua chave=valor
        const cookie = document.cookie
            .split(';')
            .filter((item) => item.includes(`${key}=`))
            .pop() || '';

        // Retorna o valor encontrado ou vazio se o mesmo não existir
        return cookie
            .split('=')
            .pop();
    }

    /**
     * Retorna uma array com tosos dos cookies da página
     *
     * @returns ICookieStorageItem[]
     */
    public getAllItems(): ICookieStorageItem[] {
        return document.cookie
            .split(';')
            .map((item) => item.trim())
            .map((item) => item.split('='))
            .map((parts) => ({ key: parts[0], data: parts[1]}))
            .filter((item) => item.key);
    }

    /**
     * Remove o valor de um cookie e determina sua data como já expirada
     *
     * @param  {string} key
     */
    public removeItem(key: string, callback: ActionCallback = () => null) {

        // Remove o item zerando o sue valor e definando uma data expirada
        this.setItem(key, null, new Date(DEFAULT_COOKIE_EXPIRES_DATE));

        // Executa callback passando como informação se o cookie persiste ou não, se persistir é erro.
        callback(this.existItem(key));
    }

}
